(() => {
  if (window.leslisProductDetailsReady) return;
  window.leslisProductDetailsReady = true;
  const reveal = (hash) => {
    if (!hash.startsWith('#LeslisProductInfo-')) return;
    const detail = document.getElementById(hash.slice(1));
    if (detail instanceof HTMLDetailsElement) detail.open = true;
  };
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href^="#LeslisProductInfo-"]');
    if (link) reveal(link.hash);
  });
  window.addEventListener('hashchange', () => reveal(location.hash));
  document.addEventListener('shopify:block:select', (event) => {
    const detail = event.target.closest('.leslis-product-accordions__item');
    if (detail) detail.open = true;
  });
  reveal(location.hash);
})();
